'use es6';

import Raven from 'Raven';
import events from '../../../events.yaml';
export default (function (isPublic) {
  return {
    events: events,
    properties: {
      namespace: 'marketplace',
      type: 'content',
      isPublic: isPublic,
      inAppOrPublic: isPublic === true ? 'public' : 'in-app'
    },
    onError: function onError(err) {
      Raven.captureMessage('usage-tracker-js event error', {
        extra: {
          message: err.message
        }
      });
    }
  };
});